import { createContext, useContext } from 'react';
import type { AdminSession, AdminUser } from '@/types/admin';

export interface AdminSessionValue {
  session: AdminSession;
  user: AdminUser;
  refresh: () => void;
}

export const AdminSessionContext = createContext<AdminSessionValue | null>(null);

/** Signed-in admin session; only available inside AdminLayout. */
export function useAdminSession(): AdminSessionValue {
  const value = useContext(AdminSessionContext);
  if (!value) {
    throw new Error('useAdminSession must be used inside AdminLayout');
  }
  return value;
}
